import React from 'react';
import './AboutSection.css';

function AboutSection() {
  return (
    <section className="about-section">
      <div className="about-section__inner">
        <h2 className="about-section__title">Boats for Every Adventure</h2>
        <h3 className="about-section__subtitle">Unsinkable Reliability Since 1990</h3>
        <p className="about-section__text">
          Vestibulum Sollicitudin Est Non Turpis Fringilla Ultricies. In Dictum Ullamcorper Leo Ut Dictum.
          Fusce Sit Amet Posuere Ante, A Hendrerit Eros. Aliquam Quis Fringilla Mi. Quisque Vel Rutrum Elit.
          Maecenas Venenatis Est Purus, A Fermentum Dui Faucibus At. Ut Suscipit Justo Sit Amet Nulla
          Varius, Vitae Commodo Enim Imperdiet.
        </p>
      </div>
    </section>
  );
}

export default AboutSection;
